/* src/app/shared/components/layout/header/header.component.scss */
/*# sourceMappingURL=header.component.css.map */
